import React, { useEffect, useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

const BaseModal = ({
  isOpen,
  toggle,
  variant = "primary",
  title,
  message,
  children,
  confirmText,
  cancelText = "ยกเลิก",
  onConfirm,
  onCancel,
  className,
  size,
  isValid = true,
}) => {
  const getButtonColor = () => {
    switch (variant) {
      case "warning":
        return "warning"
      case "danger":
        return "danger"
      default:
        return "primary"
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered={true}
      fade={true}
      className={className}
      size={size}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {message && <div className="modal-des">{message}</div>}
        {children && <div className="modal-child">{children}</div>}
      </ModalBody>
      <ModalFooter>
        <div className="d-flex gap-3 w-100 justify-content-between">
          {cancelText && (
            <Button
              color="light"
              outline
              className="w-100 max-w-52"
              onClick={() => {
                if (onCancel) onCancel()
                toggle()
              }}
            >
              {cancelText}
            </Button>
          )}

          <Button
            className="w-100 max-w-52"
            color={getButtonColor()}
            onClick={() => {
              if (isValid && onConfirm) {
                onConfirm()
              }
            }}
            disabled={!isValid}
          >
            {confirmText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default BaseModal
